module.exports = __webpack_public_path__ + "img/microphone.ff188f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand_img/microphone.png
// module id = B8Bj
// module chunks = 0